import type { PriceImprovementValidateRequest } from 'apiConnector/price-improvement';
import { priceImprovementApi } from 'apiConnector/price-improvement';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  priceImprovementValidateFailed,
  priceImprovementValidateSucceded,
} from 'state/quotes/priceEnhancements/priceImprovementResponse/priceImprovementResponse.actions';
import type { EpicWithThunk } from 'state/state.common';
import * as apiErrorHelper from 'utils/http/apiErrorHelper';
import type { HttpClientError } from 'utils/http/httpClient.model';

export function priceImprovementValidateEpic(): EpicWithThunk {
  return (action$, state$, { httpClient }) =>
    action$.pipe(
      ofType('PRICE_IMPROVEMENT_VALIDATED'),
      withLatestFrom(state$),
      mergeMap(([{ requestForPriceImprovementId, comment, priceAdjustment }]) => {
        const request: PriceImprovementValidateRequest = {
          comment,
          priceAdjustment,
        };
        return priceImprovementApi(httpClient)
          .validate(requestForPriceImprovementId, request)
          .pipe(
            map(() => priceImprovementValidateSucceded(requestForPriceImprovementId)),
            catchError((error: HttpClientError) => {
              return of(priceImprovementValidateFailed(requestForPriceImprovementId, apiErrorHelper.toApiError(error)));
            }),
          );
      }),
    );
}
